
// ---------------------------------------------------------------------------
// Interactive Advertising Bureau (IAB) Transparency and Consent Framework (TCF).
// Ads compliance for General Data Protection Regulation (GDPR) and ePrivacy Directive.
// ---------------------------------------------------------------------------
import { TCModel, TCString } from "@iabtcf/core"

// Not yet registered
const CMPID = 0;

export function attachTCF(consent)
{
	if (!consent || !consent.tcf) return consent

	const tcString = generateTCFConsentString(consent.tcf)

	return {
		...consent,
		tcf: {
			...consent.tcf,
			consentString: tcString,
		},
	}
}

// ---------------------------------------------------------------------------
// TCF v2.2 Consent String Generator
// ---------------------------------------------------------------------------

function generateTCFConsentString(tcf)
{
	// SSR / Gatsby safety
	if (typeof window === "undefined") return null

	if (CMPID === 0) return null;

	// Start

	const model = new TCModel()

	// -------------------------------------------------------------------------
	// REQUIRED TCF METADATA
	// -------------------------------------------------------------------------
	model.cmpId = CMPID // Use your CMP ID if registered with IAB
	model.cmpVersion = 1
	model.policyVersion = 4 // TCF v2.2
	model.gdprApplies = true

	// Optional but recommended:
	model.vendorListVersion = tcf.vendorListVersion || 1
	model.publisherCC = tcf.publisherCC || "PH" // Country code (PH for Philippines)

	// -------------------------------------------------------------------------
	// PURPOSE CONSENTS (1–10)
	// -------------------------------------------------------------------------
	if (tcf.purposes) {
		Object.keys(tcf.purposes)
			.sort((a, b) => Number(a) - Number(b)) // deterministic ordering
			.forEach((id) => {
				if (tcf.purposes[id] === true) {
					model.purposeConsents.set(Number(id))
				}
			})
	}

	// -------------------------------------------------------------------------
	// LEGITIMATE INTERESTS
	// -------------------------------------------------------------------------
	if (tcf.legitimateInterests) {
		Object.keys(tcf.legitimateInterests)
			.sort((a, b) => Number(a) - Number(b))
			.forEach((id) => {
				if (tcf.legitimateInterests[id] === true) {
					model.purposeLegitimateInterests.set(Number(id))
				}
			})
	}

	// -------------------------------------------------------------------------
	// SPECIAL FEATURES (1–2)
	// -------------------------------------------------------------------------
	if (tcf.specialFeatures) {
		Object.keys(tcf.specialFeatures)
			.sort((a, b) => Number(a) - Number(b))
			.forEach((id) => {
				if (tcf.specialFeatures[id] === true) {
					model.specialFeatureOptins.set(Number(id))
				}
			})
	}

	// -------------------------------------------------------------------------
	// VENDOR CONSENTS
	// -------------------------------------------------------------------------
	if (tcf.vendors) {
		Object.keys(tcf.vendors)
			.sort((a, b) => Number(a) - Number(b))
			.forEach((id) => {
				if (tcf.vendors[id] === true) {
					model.vendorConsents.set(Number(id))
				}
			})
	}

	// -------------------------------------------------------------------------
	// VENDOR LEGITIMATE INTERESTS
	// -------------------------------------------------------------------------
	if (tcf.vendorLegitimateInterests) {
		Object.keys(tcf.vendorLegitimateInterests)
			.sort((a, b) => Number(a) - Number(b))
			.forEach((id) => {
				if (tcf.vendorLegitimateInterests[id] === true) {
					model.vendorLegitimateInterests.set(Number(id))
				}
			})
	}

	// -------------------------------------------------------------------------
	// ENCODE TCF STRING
	// -------------------------------------------------------------------------
	try {
		return TCString.encode(model)
	} catch (err) {
		console.error("[TCF] Failed to encode TCString:", err)
		return null
	}
}
